export default __webpack_public_path__ + "static/media/correct-relative.09700794.svg";